import { combineEpics, ofType } from 'redux-observable';
import { of } from 'rxjs';
import { map, catchError, mergeMap } from 'rxjs/operators';
import {
  LOAD_USER,
  INIT, initSuccess, initError,
  LOGIN, loginSuccess, loginError,
  LOGOUT, logoutSuccess, logoutError,
  init as initAction,
} from './actions';

import { createErrorStream } from '../error';

const init = (action, state, { authService }) => action.pipe(
  ofType(INIT),
  mergeMap(action$ => authService
    .init()
    .pipe(
      map(initSuccess),
      catchError(createErrorStream(action$, initError)),
    )),
);

const login = (action, state, { authService }) => action.pipe(
  ofType(LOGIN),
  mergeMap(action$ => authService
    .login(action$.credentials)
    .pipe(
      mergeMap(response => of(loginSuccess(response), initAction())),
      catchError(err => of(loginError(err))),
    )),
);

const logout = (action, state, { authService }) => action.pipe(
  ofType(LOGOUT),
  mergeMap(action$ => authService
    .logout()
    .pipe(
      mergeMap(response => of(logoutSuccess(response), initAction())),
      catchError(createErrorStream(action$, logoutError)),
    )),
);

const loadUser = (action, state, { authService }) => action.pipe(
  ofType(LOAD_USER),
  mergeMap(action$ => authService
    .loadLoggedUser()
    .pipe(
      map(loginSuccess),
      catchError(createErrorStream(action$, loginError)),
    )),
);

export default combineEpics(
  init,
  login,
  logout,
  loadUser,
);
